// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS, List } from 'immutable';
import COUPON_CONSTANTS from '../Coupon.constants';
import BAGPAGE_CONSTANTS from '../../../../BagPage/BagPage.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../../../utils/cache.util';

const initialState = fromJS({
  isFetching: false,
  couponList: [],
  couponsAndOffers: [],
  isCouponHelpModalOpen: false,
  couponsFetchTimestamp: null,
  couponDetails: {},
  couponDetailsError: '',
  getCouponDetailsLoader: false,
  applyCouponCSHLoader: false,
  isCouponStatusAppliedSuccess: false,
  fromCouponTab: false,
  bonusPointsDayCouponIndex: 0,
  fromApplyCTA: false,
  couponCode: '',
  multiAddLoader: false,
  multiAddSuccess: false,
  multiAddError: null,
  loyaltyBenefits: {},
});

export const CouponReducerExtension = (state = initialState, action) => {
  switch (action.type) {
    case COUPON_CONSTANTS.RESET_COUPON_REDUCER:
      return initialState;
    case COUPON_CONSTANTS.TOGGLE_NEED_HELP_MODAL_STATE:
      return state.set('isCouponHelpModalOpen', !state.get('isCouponHelpModalOpen'));
    case COUPON_CONSTANTS.SET_NEED_HELP_MODAL_STATE:
      return state.set('isCouponHelpModalOpen', action.payload);
    case COUPON_CONSTANTS.SET_COUPONS_FETCH_TIMESTAMP:
      return state.set('couponsFetchTimestamp', action.payload);
    case COUPON_CONSTANTS.SET_LAST_APPLIED_COUPON:
      return state.set('lastAppliedCoupon', action.payload);
    case COUPON_CONSTANTS.SET_OPEN_COUPON_DETAIL_MODAL:
      return state.set('openCouponDetailModal', action.payload);
    default:
      // TODO: currently when initial state is hydrated on browser, List is getting converted to an JS Array
      if (!(state instanceof fromJS)) {
        return fromJS(state);
      }
      return state;
  }
};

// eslint-disable-next-line complexity
const CouponReducer = (state = initialState, action) => {
  switch (action.type) {
    case COUPON_CONSTANTS.SHOW_LOADER:
      return state.set('isFetching', true);
    case COUPON_CONSTANTS.FROM_COUPON_TAB:
      return state.set('fromCouponTab', action.payload);
    case COUPON_CONSTANTS.FROM_APPLY:
      return state.set('fromApplyCTA', action.payload);

    case COUPON_CONSTANTS.SET_COUPON_LIST:
    case BAGPAGE_CONSTANTS.SET_COUPONS_DATA:
      return state
        .set('isFetching', false)
        .set('couponsAndOffers', List(action.payload.coupons))
        .set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload.couponCachingTTL));
    case COUPON_CONSTANTS.SET_BONUS_POINT_DAY:
      return state.set('bonusPointsDay', action.payload);
    case COUPON_CONSTANTS.SET_NON_LOYALTY_COUPON_LIST:
      return state.set('normalCoupons', List(action.payload));
    case COUPON_CONSTANTS.SET_BONUS_POINT_DAY_COUPON_INDEX:
      return state.set('bonusPointsDayCouponIndex', action.payload);

    case BAGPAGE_CONSTANTS.SET_COUPONS_DATA_FOR_HOME_CAROUSEL:
      return state
        .set('isFetching', false)
        .set('couponsAndOffers', List(action.payload))
        .set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload.couponCachingTTL));
    case COUPON_CONSTANTS.SET_COUPON_DETAILS:
      return state.set('couponDetails', action.payload.coupon);
    case COUPON_CONSTANTS.RESET_COUPON_DETAILS:
      return state.set('couponDetails', null);
    case COUPON_CONSTANTS.TOGGLE_MULTI_LOADER:
      return state.set('multiAddLoader', action.payload);
    case COUPON_CONSTANTS.SET_MULTI_ADD_SUCCESS:
      return state.set('multiAddSuccess', action.payload);
    case COUPON_CONSTANTS.SET_MULTI_ADD_ERROR:
      return state.set('multiAddError', action.payload);
    case COUPON_CONSTANTS.SET_COUPON_CODE:
      return state.set('couponCode', action.payload);
    case COUPON_CONSTANTS.CALL_COUPON_ACTION:
      return state.set('shouldCallCouponAction', action.payload);
    case COUPON_CONSTANTS.SET_COUPON_DETAILS_ERROR:
      return state.set('couponDetailsError', action.payload);
    case COUPON_CONSTANTS.SET_COUPON_DETAILS_LOADER:
      return state.set('getCouponDetailsLoader', action.payload);
    case COUPON_CONSTANTS.SET_APPLY_COUPON_CSH_LOADER:
      return state.set('applyCouponCSHLoader', action.payload);
    case COUPON_CONSTANTS.SET_APPLY_COUPON_CSH_ERROR:
      return state.setIn(['couponDetails', 'error'], action.payload.msg);
    case COUPON_CONSTANTS.CLEAR_COUPON_TTL:
      return state.set(DEFAULT_REDUCER_KEY, null);
    case COUPON_CONSTANTS.HIDE_LOADER:
      return state.set('isFetching', false);
    case COUPON_CONSTANTS.SET_COUPON_APPLIED_STATUS:
      return state.set('isCouponStatusAppliedSuccess', action.payload);
    case COUPON_CONSTANTS.SET_STATUS_COUPON:
      return state.set(
        'couponsAndOffers',
        state.get('couponsAndOffers').map((coupon) => {
          if (coupon.id === action.payload.promoCode)
            return { ...coupon, labelStatus: action.payload.status };
          return coupon;
        })
      );
    case COUPON_CONSTANTS.SET_ERROR:
      return state.set(
        'couponsAndOffers',
        state.get('couponsAndOffers').map((promo) => {
          return promo.id === action.payload.couponCode
            ? { ...promo, error: action.payload.msg }
            : promo;
        })
      );
    case COUPON_CONSTANTS.RESET_COUPON_STATE:
      return state.set('couponsAndOffers', List([]));
    case COUPON_CONSTANTS.SET_ONHOLD_COUPON:
      return state.set(
        'couponsAndOffers',
        state.get('couponsAndOffers').map((coupon) => {
          if (coupon.id === action.payload.promoCode)
            return {
              ...coupon,
              isOnHold: action.payload.isOnHold,
              status: action.payload.status,
              labelStatus: action.payload.labelStatus,
            };
          return coupon;
        })
      );
    case COUPON_CONSTANTS.SET_COUPON_TERMS_AND_CONDITIONS:
      return state.set(
        'couponsAndOffers',
        state.get('couponsAndOffers').map((coupon) => {
          return coupon.id === action.payload.coupon.id &&
            coupon.promotionId === action.payload.coupon.promotionId
            ? { ...coupon, legalText: action.payload.couponsTermsNConditions.legalText }
            : coupon;
        })
      );
    case COUPON_CONSTANTS.SET_BENEFITS:
      return state.set('loyaltyBenefits', action.payload);
    default:
      return CouponReducerExtension(state, action);
  }
};

export default CouponReducer;
